export const MAX_DISTANCE_FILTER_SHORT_NAME = "max_distance"
export const MIN_DISTANCE_FILTER_SHORT_NAME = "min_distance"

export const DISTANCE_INCREMENT_VALUE = 25

export const maxDistanceDefault = 75
export const eventsMaxDistanceDefault = 50
export const minDistanceDefault = 0

export const MAX_DISTANCE_FILTER_CONFIG = {
  short_name: MAX_DISTANCE_FILTER_SHORT_NAME,
  default_values: maxDistanceDefault,
  is_default: value => testMaxDistanceDefault(value), //right before clean up
  format_to_api: value => formatMaxDistanceForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatMaxDistanceFromURL(value) //
}

export const testMaxDistanceDefault = value => {
  if (value !== maxDistanceDefault) {
    return false
  }
  return true
}

export const MIN_DISTANCE_FILTER_CONFIG = {
  short_name: MIN_DISTANCE_FILTER_SHORT_NAME,
  default_values: minDistanceDefault,
  is_default: value => testMinDistanceDefault(value), //right before clean up
  format_to_api: value => formatMinDistanceForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatMinDistanceFromURL(value) //
}

export const testMinDistanceDefault = value => {
  if (value !== minDistanceDefault) {
    return false
  }
  return true
}

export const formatMaxDistanceFromURL = value => {
  let cleanValue = value
  
  if (value <= 0) {
    cleanValue = 1
  }
  return cleanValue
}

export const formatMinDistanceFromURL = value => {
  let cleanValue = value
  
  if (value < 0) {
    cleanValue = 0
  }
  return cleanValue
}

//api
export const formatMaxDistanceForAPI = value => {
  if (value) {
    return {
      max_distance: value.toString() + "mi"
    }
  } else {
    return {}
  }
}

export const formatMinDistanceForAPI = value => {
  if (value) {
    return {
      min_distance: value.toString() + "mi"
    }
  } else {
    return {}
  }
}

export const distanceOptions = [
  {
    key: "25",
    text: "25 Miles",
    value: 25,
    content: "25 Miles"
  },
  {
    key: "50",
    text: "50 Miles",
    value: 50,
    content: "50 Miles"
  },
  {
    key: "100",
    text: "100 Miles",
    value: 100,
    content: "100 miles"
  },
  {
    key: "all",
    text: "Ride The World",
    value: 10000,
    content: "Ride The World"
  }
]